/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandChecksFromJSON, BrandChecksToJSON } from './BrandChecks';
/**
 * Check if a given object implements the BrandHealth interface.
 */
export function instanceOfBrandHealth(value) {
    if (!('brandId' in value) || value['brandId'] === undefined)
        return false;
    if (!('checks' in value) || value['checks'] === undefined)
        return false;
    if (!('domain' in value) || value['domain'] === undefined)
        return false;
    if (!('isPendingNs' in value) || value['isPendingNs'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('overall' in value) || value['overall'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function BrandHealthFromJSON(json) {
    return BrandHealthFromJSONTyped(json, false);
}
export function BrandHealthFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brandId': json['brand_id'],
        'checks': BrandChecksFromJSON(json['checks']),
        'domain': json['domain'],
        'isPendingNs': json['is_pending_ns'],
        'label': json['label'],
        'overall': json['overall'],
        'updatedAt': json['updated_at'],
    };
}
export function BrandHealthToJSON(json) {
    return BrandHealthToJSONTyped(json, false);
}
export function BrandHealthToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand_id': value['brandId'],
        'checks': BrandChecksToJSON(value['checks']),
        'domain': value['domain'],
        'is_pending_ns': value['isPendingNs'],
        'label': value['label'],
        'overall': value['overall'],
        'updated_at': value['updatedAt'],
    };
}
